import ActivateCouponError from './ActivateCouponError';
class ActivateCouponNotFound extends ActivateCouponError {
    constructor(options) {
        super('The promotional coupon code is not found', options);
    }
}
export default ActivateCouponNotFound;
